import { ACTION_CONST } from "../../constants";

export function changeLanguage(language) {
    return {
        type: ACTION_CONST.LANGUAGE_CHANGE,
        language
    }
}